import React, { useState } from 'react';
import { SearchResultItem } from './SearchResultItem';

export function SearchResultGroup({ group, query, onSelect }) {
  const [expanded, setExpanded] = useState(false);
  const items = Array.isArray(group.items) ? group.items : [];
  const maxVisible = group.maxVisible || 5;
  const visible = expanded ? items : items.slice(0, maxVisible);
  const hidden = Math.max(0, items.length - visible.length);

  return (
    <div className="kp-search-group">
      <div className="kp-search-group-header">
        <span>{group.label}</span>
        <span className="kp-search-group-count">{items.length}</span>
      </div>
      {visible.map((r) => (
        <SearchResultItem
          key={r.module.to}
          result={r}
          query={query}
          onSelect={onSelect}
        />
      ))}
      {hidden > 0 ? (
        <button
          type="button"
          className="kp-search-group-show"
          onClick={() => setExpanded(true)}
        >
          Visa {hidden} till
        </button>
      ) : null}
    </div>
  );
}
